import type { ReactNode } from 'react';

/**
 * Dashboard-scale section header — a refined, compact heading used across the
 * dashboard and its embedded panels so every section reads as one system.
 * Distinct from the large marketing `SectionHeading` used on landing/search.
 */
export function PanelHeader({
  title,
  description,
  count,
  icon,
  action,
}: {
  title: string;
  description?: string;
  count?: number;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex min-w-0 items-start gap-3">
        {icon && (
          <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center bg-accent-soft text-accent">
            {icon}
          </span>
        )}
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="text-sm font-semibold tracking-[-0.01em] text-ink">{title}</h3>
            {typeof count === 'number' && <span className="chip tabular-nums">{count}</span>}
          </div>
          {description && <p className="mt-0.5 text-sm leading-[1.5] text-dim">{description}</p>}
        </div>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
